import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  hasMore: true,
  page: 1,
  wsConnected: false,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload.results || [];
      if (action.payload.unread_count !== undefined) {
        state.unreadCount = action.payload.unread_count;
      }
      state.hasMore = action.payload.has_more ?? false;
      state.page = 1;
      state.isLoading = false;
    },
    appendNotifications: (state, action) => {
      const existingIds = new Set(state.notifications.map((n) => n.id));
      const newItems = (action.payload.results || []).filter(
        (n) => !existingIds.has(n.id),
      );
      state.notifications = [...state.notifications, ...newItems];
      state.hasMore = action.payload.has_more ?? false;
      state.isLoading = false;
    },
    prependNotification: (state, action) => {
      const exists = state.notifications.some((n) => n.id === action.payload.id);
      if (!exists) {
        state.notifications = [action.payload, ...state.notifications];
        state.unreadCount = state.unreadCount + 1;
      }
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    markOneRead: (state, action) => {
      const notif = state.notifications.find((n) => n.id === action.payload);
      if (notif && !notif.is_read) {
        notif.is_read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllRead: (state) => {
      state.notifications.forEach((n) => {
        n.is_read = true;
      });
      state.unreadCount = 0;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    incrementPage: (state) => {
      state.page = state.page + 1;
    },
    setWsConnected: (state, action) => {
      state.wsConnected = action.payload;
    },
    resetNotifications: () => initialState,
  },
});

export const {
  setNotifications,
  appendNotifications,
  prependNotification,
  setUnreadCount,
  markOneRead,
  markAllRead,
  setLoading,
  incrementPage,
  setWsConnected,
  resetNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
